import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EncrDecrService } from './encode.decode.service';
import { UserData } from '../_models/users';
import { environment } from '../../environments/environment';
import { AdminData } from '../_models/admin';

@Injectable({
  providedIn: 'root'
})
export class ChecksService {
  constructor(
    private router: Router,
    private EncrDecr: EncrDecrService
  ) {}

  checkLoggedin(data) {
    if (data.success !== true) {
      if (data.code == 10018) {
        this.router.navigate(['/login']);
      }
    }
  }

  getToken(home = false) {
    return this.checkSession(home).token.token;
  }

  checkLogin() {
    var currentTime = Math.floor((Date.now() / 1000));
    if (localStorage.getItem('key') !== null) {

      let userData = localStorage.getItem('userData');
      try {
        let keydata = JSON.parse(atob(localStorage.getItem('key')));
        var data: UserData = JSON.parse(this.EncrDecr.get(environment.localKey + keydata.key, userData));
      
        if (keydata.expire > currentTime) {
          this.router.navigate(["home"]);
        }
      } catch { }
    }

  }

  checkSession(home: boolean = false) {
    var currentTime = Math.floor((Date.now() / 1000));

    if (localStorage.getItem('key') !== null) {
      let keydata = JSON.parse(atob(localStorage.getItem('key')));
      
      let userData = localStorage.getItem('userData');

      var url = this.router.url.slice(1);
      if (url === "") {
        localStorage.removeItem("route");
      } else {
        localStorage.setItem('route', url);
      }
      try {
        var data: AdminData = JSON.parse(this.EncrDecr.get(environment.localKey + keydata.key, userData));


        if (keydata.expire > currentTime) {
          var currentTime = Math.floor((Date.now() / 1000) + (60 * 10));
          
          var newKeydata = {
            key: keydata.key,
            expire: currentTime.toString()
          }
          
          localStorage.setItem('key', btoa(JSON.stringify(newKeydata)));
          localStorage.setItem('auth', "1");
          return data;
        } else {
          var sessionData: object = {
            username: data.username,
            nickName: data.nickName,
            lastName: data.lastName,
            firstName: data.firstName
          }

          localStorage.removeItem("userData");
          localStorage.setItem('auth', "0");
          localStorage.setItem('sessionKey', btoa(JSON.stringify(sessionData)));
          if (home === false) {
            this.router.navigate(['/lock']);
          } else {
            return new AdminData();
          }
        }
      } catch {
        localStorage.setItem('auth', "0");
        if (home === false) {
          this.router.navigate(['/login']);
        } else {
          return new AdminData();
        }
      }
    } else {
      localStorage.setItem('auth', "0");
      if (home === false) {
        this.router.navigate(['/login']);
      }
      return new AdminData();
    }

    return null;
  }

  getAdminData() {
    return this.checkSession(true);
  }

  isSuperAdmin(adminData: AdminData = null) {
    const data = adminData || this.getAdminData();
    return data?.rights?.super === true;
  }

  isStaffOnly(adminData: AdminData = null) {
    const data = adminData || this.getAdminData();
    const slug = String(data?.rights?.slug || '').toLowerCase();
    const title = String(data?.rights?.adminType || '').toLowerCase();
    return slug === 'staff' || title === 'staff';
  }

  hasPage(page: string|string[], adminData: AdminData = null) {
    const data = adminData || this.getAdminData();
    if (!data?.rights) {
      return false;
    }

    if (this.isSuperAdmin(data)) {
      return true;
    }

    const pages = (data.rights.pages || []).map(row => String(row).toLowerCase());
    const requestedPages = Array.isArray(page) ? page : [page];

    if (this.isStaffOnly(data) && (requestedPages.includes('hr.leave') || requestedPages.includes('hr.expense') || requestedPages.includes('hr.announcement'))) {
      return true;
    }

    return requestedPages.some(row => pages.includes(String(row).toLowerCase()));
  }

  canRead(page: string|string[]) {
    return this.hasPage(page);
  }

  canWrite(page: string|string[]) {
    const data = this.getAdminData();
    return this.hasPage(page, data) && (data?.rights?.write === true || this.isSuperAdmin(data));
  }

  canModify(page: string|string[]) {
    const data = this.getAdminData();
    return this.hasPage(page, data) && (data?.rights?.modify === true || this.isSuperAdmin(data));
  }

  closeModal(modalId: string = '') {
    const selector = modalId !== '' ? '#' + modalId : '.modal.show';
    document.querySelectorAll(selector).forEach((modal: HTMLElement) => {
      const dismissButton = modal.querySelector('[data-dismiss="modal"]') as HTMLElement;
      if (dismissButton) {
        dismissButton.click();
      }
      modal.classList.remove('show');
      modal.setAttribute('aria-hidden', 'true');
      modal.style.display = 'none';
    });

    document.querySelectorAll('.modal-backdrop').forEach(backdrop => backdrop.remove());
    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('padding-right');
  }

  pageForUrl(url: string) {
    const cleanUrl = String(url || '').split('?')[0].replace(/^\/+/, '');

    if (cleanUrl === '' || cleanUrl === 'profile' || cleanUrl.startsWith('profile/')) {
      return 'home';
    }

    if (cleanUrl === 'settings/administrator/right') {
      return 'administrators.right';
    }

    if (cleanUrl.startsWith('settings/administrator')) {
      return 'administrators';
    }

    if (cleanUrl.startsWith('settings/countries/areas')) {
      return 'country.areas';
    }

    if (cleanUrl.startsWith('settings/countries')) {
      return 'country';
    }

    if (cleanUrl.startsWith('settings/currencies')) {
      return 'country';
    }

    if (cleanUrl.startsWith('settings/document') || cleanUrl.startsWith('settings/identity')) {
      return 'document.type';
    }

    if (cleanUrl.startsWith('dealslip')) {
      return 'dealSlip';
    }

    if (cleanUrl.startsWith('users/kyc')) {
      return 'users.kyc';
    }

    if (cleanUrl.startsWith('users')) {
      return 'users';
    }

    if (cleanUrl.startsWith('hr/staff')) {
      return 'hr.staff';
    }

    if (cleanUrl.startsWith('hr/leave-management')) {
      return ['hr.leave', 'hr.staff', 'users'];
    }

    if (cleanUrl.startsWith('hr/payroll-tax')) {
      return ['hr.payroll', 'hr.staff', 'users'];
    }

    if (cleanUrl.startsWith('hr/performance-epa')) {
      return ['hr.performance', 'hr.staff', 'users'];
    }

    if (cleanUrl.startsWith('hr/expenses-approvals')) {
      return ['hr.expense', 'hr.staff', 'users'];
    }

    if (cleanUrl.startsWith('hr/announcements-reports')) {
      return ['hr.announcement', 'hr.staff', 'users'];
    }

    if (cleanUrl.startsWith('hr/departments')) {
      return ['hr.department', 'hr.staff', 'users'];
    }

    if (cleanUrl.startsWith('hr/designations')) {
      return ['hr.designation', 'hr.staff', 'users'];
    }

    if (cleanUrl.startsWith('hr/org-chart')) {
      return ['hr.organogram', 'hr.staff', 'users'];
    }

    if (cleanUrl.startsWith('hr')) {
      return ['hr.staff', 'users'];
    }

    if (cleanUrl.startsWith('treasury')) {
      return 'treasury';
    }

    if (cleanUrl.startsWith('finance-pl')) {
      return 'finance.pl';
    }

    return cleanUrl;
  }

  canAccessUrl(url: string) {
    const page = this.pageForUrl(url);
    return page === 'home' || this.hasPage(page);
  }

  firstAllowedRoute() {
    const routeOptions = [
      { route: '/', page: 'home' },
      { route: '/dealslip', page: 'dealSlip' },
      { route: '/hr/leave-management', page: ['hr.leave', 'hr.staff', 'users'] },
      { route: '/hr/expenses-approvals', page: ['hr.expense', 'hr.staff', 'users'] },
      { route: '/hr/announcements-reports', page: ['hr.announcement', 'hr.staff', 'users'] },
      { route: '/hr/employee-profiles-kin', page: ['hr.staff', 'users'] },
      { route: '/users', page: 'users' },
      { route: '/users/kyc', page: 'users.kyc' },
      { route: '/settings/administrator', page: 'administrators' },
      { route: '/settings/administrator/right', page: 'administrators.right' },
      { route: '/settings/countries', page: 'country' },
      { route: '/settings/document', page: 'document.type' },
    ];

    const allowed = routeOptions.find(row => row.page === 'home' || this.hasPage(row.page));
    return allowed?.route || '/';
  }

  getRandomString(length) {
    var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for ( var i = 0; i < length; i++ ) {
        result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    
    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
  }
}
